(function () {
  // CONFIG
  var KEY_HOLDER_HANDLE = 'individual-key-holder';
  var MICRO_VARIANT_ID  = 42195089686776;

  // Must exist on eligible fob line items (set via hidden input on product form)
  var ELIGIBLE_PROP = 'Eligible Free Key Holder';

  // Properties we set when WE auto-add Micro
  var FREE_PROP = 'Free with key fob';
  var AUTO_PROP = 'Auto-added micro holder';

  // --- TUNING ---
  var CART_SETTLE_MS = 1200;      // wait after last cart mutation
  var SYNC_DEBOUNCE_MS = 300;     // debounce sync calls

  var syncing = false;
  var lastCartMutationAt = 0;
  var scheduledRetry = null;

  function now() { return Date.now(); }

  function debounce(fn, wait) {
    var t;
    return function () {
      clearTimeout(t);
      t = setTimeout(fn, wait);
    };
  }

  function getCart() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); });
  }

  function cartChange(key, qty) {
    return fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); });
  }

  function cartAdd(variantId, qty, props) {
    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: qty, properties: props || {} })
    }).then(function (r) { return r.json(); });
  }

  function markMutation() {
    lastCartMutationAt = now();
  }

  function scheduleRetryAfterSettle() {
    if (scheduledRetry) return;
    var wait = Math.max(0, CART_SETTLE_MS - (now() - lastCartMutationAt)) + 50;
    scheduledRetry = setTimeout(function () {
      scheduledRetry = null;
      syncKeyHolders();
    }, wait);
  }

  function computeCounts(cart) {
    var eligibleQty = 0;
    var holderQty = 0;
    var holderLines = [];

    cart.items.forEach(function (item) {
      var props = item.properties || {};

      // Eligible fobs
      if (props[ELIGIBLE_PROP] === 'true' || props[ELIGIBLE_PROP] === true) {
        eligibleQty += item.quantity;
      }

      // Any key holder variant
      if (item.handle === KEY_HOLDER_HANDLE) {
        holderQty += item.quantity;
        holderLines.push({
          key: item.key,
          qty: item.quantity,
          isAuto: (props[AUTO_PROP] === 'true' || props[AUTO_PROP] === true),
          isPaid: item.price > 0
        });
      }
    });

    return { eligibleQty: eligibleQty, holderQty: holderQty, holderLines: holderLines };
  }

  // Double-check after settle before doing "big destructive" operations
  function confirmNoEligibleFobsThenRemoveAllHolders() {
    return getCart().then(function (cart2) {
      var c2 = computeCounts(cart2);

      // If eligible fobs exist now, do NOT remove holders
      if (c2.eligibleQty > 0) return;

      // remove all holder lines (auto first)
      c2.holderLines.sort(function (a, b) {
        if (a.isAuto !== b.isAuto) return (b.isAuto === true) - (a.isAuto === true);
        return 0;
      });

      return c2.holderLines.reduce(function (p, line) {
        return p.then(function () { return cartChange(line.key, 0); });
      }, Promise.resolve());
    });
  }

  var syncKeyHolders = debounce(function () {
    if (syncing) return;
    syncing = true;

    getCart()
      .then(function (cart) {
        var c = computeCounts(cart);

        // ---- RULE: holders must equal eligible fobs ----

        // A) eligibleQty == 0 -> ONLY remove all holders after cart settles, and confirm again
        if (c.eligibleQty === 0 && c.holderQty > 0) {
          // If cart is still settling, wait
          if ((now() - lastCartMutationAt) < CART_SETTLE_MS) {
            scheduleRetryAfterSettle();
            return;
          }
          // Confirm again on a fresh cart read before removing everything
          return confirmNoEligibleFobsThenRemoveAllHolders();
        }

        // B) Too many holders -> reduce extras (auto first, then free before paid)
        if (c.holderQty > c.eligibleQty) {
          var extra = c.holderQty - c.eligibleQty;

          c.holderLines.sort(function (a, b) {
            if (a.isAuto !== b.isAuto) return (b.isAuto === true) - (a.isAuto === true);
            if (a.isPaid !== b.isPaid) return (a.isPaid === true) - (b.isPaid === true);
            return 0;
          });

          return c.holderLines.reduce(function (p, line) {
            return p.then(function () {
              if (extra <= 0) return;
              var take = Math.min(line.qty, extra);
              extra -= take;
              return cartChange(line.key, line.qty - take);
            });
          }, Promise.resolve());
        }

        // C) Missing holders -> add Micro, but only after settle (avoid racing premium add)
        if (c.holderQty < c.eligibleQty) {
          var missing = c.eligibleQty - c.holderQty;

          if ((now() - lastCartMutationAt) < CART_SETTLE_MS) {
            scheduleRetryAfterSettle();
            return;
          }

          return cartAdd(MICRO_VARIANT_ID, missing, (function () {
            var o = {};
            o[FREE_PROP] = true;
            o[AUTO_PROP] = true;
            return o;
          })());
        }

        // D) matched -> nothing
      })
      .catch(function (e) {
        console.error('[KeyHolderSync]', e);
      })
      .finally(function () {
        syncing = false;
      });

  }, SYNC_DEBOUNCE_MS);

  // Expose for testing
  window.syncFreeKeyHolders = syncKeyHolders;

  // Run on load
  document.addEventListener('DOMContentLoaded', function () {
    markMutation();
    syncKeyHolders();
  });

  // Re-run after cart AJAX calls
  (function () {
    var origFetch = window.fetch;
    window.fetch = function (resource, init) {
      var url = (typeof resource === 'string') ? resource : (resource && resource.url) || '';
      var isCartMutation =
        url.indexOf('/cart/add') !== -1 ||
        url.indexOf('/cart/change') !== -1 ||
        url.indexOf('/cart/update') !== -1 ||
        url.indexOf('/cart/clear') !== -1;

      if (isCartMutation) markMutation();

      var p = origFetch.apply(this, arguments);

      if (isCartMutation) {
        p.finally(function () {
          syncKeyHolders();
        });
      }
      return p;
    };
  })();
})();
